import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import PropTypes from 'prop-types';
import {assessmentTiers} from "../components/resultItems/AssessmentTier";


class CategoryRefOptionList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
    this.childNodes = {};
    this.registerChild = this.registerChild.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  renderChildren(children, option) {
    return React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        ...option,
        optionID: option.id,
        ref: (comp) => {
          this.childNodes[option.id] = comp;
          if (typeof child.ref === "function") {
            child.ref(comp);
          }
        }
      });
    });
  }

  getChildren() {
    return Object.keys(this.childNodes).map((k) => this.childNodes[k]);
  }


  registerChild(id, child) {
    if(!child) {
      delete this.childNodes[id]
    } else {
      this.childNodes[id] = child;
    }
  }

  componentDidMount() {
  }

  render() {
    let props = this.props;
    return (
      <Card onExpandChange={this.toggleExpanded}>
        <CardHeader
          title={props.title + " (" + props.options.length + ")"}
          actAsExpander={props.expandable}
          showExpandableButton={props.expandable} />
        <CardText style={{display: this.state.expanded ? 'block' : 'none'}}>
        {
          props.options.map((option) => (
            <div key={option.id}>
              {this.renderChildren(props.children, option)}
            </div>
          ))
        }
        </CardText>
      </Card>
    )
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded})
  }
}

class CategorizedRefOptionList extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.categories !== nextProps.categories ||
      this.props.options !== nextProps.options ||
      this.props.expandable !== nextProps.expandable;
  }

  getChildren() {
    return Object.keys(this.refs).reduce((children, key) => {
      let list = this.refs[key];
      return children.concat(list.getChildren());
    }, []);
  }

  render() {
    let props = this.props;
    let categories = this.props.filterValue === "tier" ? assessmentTiers : props.categories
    return (
      <div>
      {
          categories.map((category) => {
          let options;
          switch (this.props.filterValue) {
            case 'tier':
              options = props.options.filter((t) => t.assessmentTier === category.id)
              break;
            case 'inputCategory':
              options = props.options.filter((t) => t.inputCategory.id === category.id);
              break;
            case 'category':
            default:
              options = props.options.filter((t) => t.category.id === category.id);
              break;
          }
          if (options.length) {
            return <CategoryRefOptionList
                       key={"cat" + category.id}
                       ref={"cat" + category.id}
                      {...category}
                      options={options}
                      expandable={props.expandable}
                      >{props.children}</CategoryRefOptionList>
          } else {
            return null
          }
        })
      }
      </div>
    )
  }
}

CategorizedRefOptionList.propTypes = {
  options: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
}

CategorizedRefOptionList.defaultProps = {
  expandable: true
}

export default CategorizedRefOptionList;
